module.exports = __webpack_public_path__ + "static/impact-analysis-hubs-d76383c8f934333bda1aef33c09419c0.png";